import { fromJS } from 'immutable';
import * as c from 'actions/feedback/constants';

export const initialState = fromJS({
  questions: [],
  questionsLoading: false,
  answersLoading: false,
  submissionStatusLoading: false,
  submitted: false,
  submittedThisSession: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case c.REQUEST_FEEDBACK_QUESTIONS:
      return state.merge(
        fromJS({
          questionsLoading: true,
          questions: [],
        })
      );
    case c.REQUEST_FEEDBACK_QUESTIONS_SUCCESS:
      return state.merge(
        fromJS({
          questionsLoading: false,
          questions: action.questions,
        })
      );
    case c.REQUEST_FEEDBACK_QUESTIONS_FAILURE:
      return state.merge(
        fromJS({
          questionsLoading: false,
          questions: [],
        })
      );
    case c.REQUEST_FEEDBACK_SUBMISSION_STATUS:
      return state.set('submissionStatusLoading', true);
    case c.REQUEST_FEEDBACK_SUBMISSION_STATUS_SUCCESS:
      if (!action.submitted && state.get('submittedThisSession')) {
        return state.set('submissionStatusLoading', false);
      }

      return state.merge(
        fromJS({
          submissionStatusLoading: false,
          submitted: action.submitted,
          submittedThisSession: false,
        })
      );
    case c.REQUEST_FEEDBACK_SUBMISSION_STATUS_FAILURE:
      if (state.get('submittedThisSession')) {
        return state.set('submissionStatusLoading', false);
      }

      return state.merge(
        fromJS({
          submissionStatusLoading: false,
          submitted: false,
          submittedThisSession: false,
        })
      );
    case c.SUBMIT_FEEDBACK_ANSWERS:
      return state.set('answersLoading', true);
    case c.FEEDBACK_SUBMISSION_SUCCESS:
      return state.merge(
        fromJS({
          answersLoading: false,
          submitted: true,
          submittedThisSession: true,
        })
      );
    case c.FEEDBACK_SUBMISSION_FAILURE:
      return state.set('answersLoading', false);
    default:
      return state;
  }
};
